import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import firebase from 'firebase';
import AboutPage from './pages/AboutPage';
import HomePage from './pages/HomePage';
import SearchPage from './pages/SearchPage';
import SignIn from './pages/SignIn';
import DefinitionPage from './pages/DefinitionPage';
import PrimarySearchAppBar from './components/PrimarySearchAppBar';
import HomeAppBar from './components/HomeAppBar';
import { Switch } from 'react-router-dom';
import AddTermPage from './pages/AddTermPage';
import ModifyTermPage from './pages/ModifyTermPage';
import AddVideoPage from './pages/AddVideoPage';
import ProfilePage from './pages/ProfilePage';
import BackendHelpers from './utils/BackendHelpers';
import CreateAccountPage from '../src/pages/CreateAccountPage';
import AdminPage from '../src/pages/AdminPage';
import { withSnackbar } from 'notistack';

/* eslint react/no-direct-mutation-state: "off"*/

// Configure Firebase.
const config = {
  apiKey: 'AIzaSyB_liTtnYJvMgRoKU7tdFXyrp7bwBv6XNw',
  authDomain: 'aslstem.firebaseapp.com',
  databaseURL: 'https://aslstem.firebaseio.com',
  projectId: 'aslstem',
  storageBucket: 'aslstem.appspot.com',
  messagingSenderId: '687282065748',
  appId: '1:687282065748:web:48925752eb7a8c3a9ef8c1',
  measurementId: 'G-4C0RLR9TEC',
};

const getParentTerms = (definitions) => {
  let parentTerms = [];
  Object.keys(definitions).forEach((key) => {
    if (!definitions[key]['Parent'] && key !== 'undefined') {
      parentTerms.push(key); // No parent, so must be a top-level category
    }
  });
  return parentTerms;
};

// Make Firebase definitions formatted
const parseDefinitions = (definitions) => {
  let res = {};
  Object.keys(definitions).forEach((key) => {
    let curr = definitions[key];
    const name = curr['Name'];
    res[name] = {};
    res[name]['Key'] = key; // Store key for convenience
    res[name]['References'] = curr['References'];
    if (curr['Parent']) {
      res[name]['Parent'] = curr['Parent'];
    }
    res[name]['Example'] = curr['Example'];
    res[name]['Definition'] = curr['Definition'];
    res[name]['Source'] = curr['Source'];
  });
  // Populate "Children" fields
  Object.keys(res).forEach((curr) => {
    let parents = [res[curr].Parent];
    // Treat references as parents
    if (res[curr].References) {
      Object.keys(res[curr].References).forEach((key) => {
        parents.push(res[curr].References[key]);
      });
    }
    parents.forEach((parent) => {
      if (parent && parent !== '') {
        if (!res[parent].Children) {
          res[parent].Children = {};
        }
        res[parent].Children[curr] = curr;
      }
    });
  });
  return res;
};

// Make Firebase videos formatted
const parseVideos = (videos) => {
  let res = {};
  Object.keys(videos).forEach((key) => {
    let curr = videos[key];
    const name = curr['name'];
    if (!res[name]) {
      res[name] = {};
    }
    let length = Object.keys(res[name]).length;
    res[name][length] = {
      uploader: curr['uploader'],
      rating: curr['rating'],
      ratingCount: curr['ratingCount'],
      uploadDate: curr['uploadDate'],
      url: curr['url'],
      dbIndex: key,
    };
  });
  return res;
};

class App extends Component {
  constructor(props) {
    super(props);
    firebase.initializeApp(config);
    // const db = firebase.database();

    this.state = {
      user: undefined,
      definitions: cachedParentTermData,
      categories: cachedParentTerms,
      videos: undefined,
    };

    firebase.auth().onAuthStateChanged((user) => {
      if (!user.emailVerified) {
        firebase.auth().currentUser.sendEmailVerification();
        alert(
          'You have not verified your email yet. Please check ' +
            user.email +
            ' to verify your email. The email may take up to 5 minutes to send.'
        );
      }
      firebase
        .database()
        .ref('/users/' + user.uid)
        .once('value')
        .then((snapshot) => {
          const val = snapshot.val();
          if (val) {
            this.setState({
              user: {
                username: val.username,
                name: val.fullname,
                level: val.level,
                ratings: val.ratings,
                email: user.email,
                uid: user.uid,
              },
            });
          } else {
            BackendHelpers.getUserNames().then((usernames) => {
              this.setState({
                usernames,
                user: {
                  name: user.displayName,
                  level: 'USER',
                  email: user.email,
                  uid: user.uid,
                },
                createAccount: true,
              });
            });
          }
        });
    });
  }

  componentDidMount() {
    firebase
      .database()
      .ref('/terms')
      .once('value')
      .then((val) => {
        const definitions = parseDefinitions(val.toJSON());
        this.setState({
          definitions: definitions,
          categories: getParentTerms(definitions),
        });
      });
    firebase
      .database()
      .ref('/videos')
      .once('value')
      .then((val) => this.setState({ videos: parseVideos(val.toJSON()) }));
  }

  addVideo = (videoData) => {
    const term = videoData.term;
    BackendHelpers.addVideo(this.state.user.uid, videoData);

    if (this.state.videos[term]) {
      this.state.videos[term][
        Object.keys(this.state.videos[term]).length
      ] = videoData;
    } else {
      this.state.videos[term] = [videoData];
    }
    this.forceUpdate();
  };

  // Adds new term by updating state and Firebase
  addTerm = (termData) => {
    const { term, parent } = termData;
    BackendHelpers.addTerm(termData);
    this.state.definitions[term] = {
      Definition: termData.Definition,
      Source: termData.Source,
      Example: termData.Example,
      Parent: termData.Parent,
    };
    // Add this term to the parent's children list
    if (parent && parent !== '' && this.state.definitions[parent]) {
      if (this.state.definitions[parent].Children) {
        this.state.definitions[parent].Children[
          Object.keys(this.state.definitions[parent].Children).length
        ] = term;
      } else {
        this.state.definitions[parent].Children = [term];
      }
    }
    this.forceUpdate();
  };

  render() {
    return this.state.definitions === undefined ||
      this.state.videos === undefined ? (
      <div />
    ) : this.state.createAccount ? (
      <CreateAccountPage
        email={this.state.user.email}
        name={this.state.user.name}
        usernames={this.state.usernames}
        createAccount={(username, fullname) => {
          BackendHelpers.createAccount(
            this.state.user.uid,
            username,
            fullname,
            this.state.user.email
          ).then(() => {
            this.setState((prevState) => {
              let prevUser = prevState.user;
              prevUser['username'] = username;
              prevUser['name'] = fullname;
              return { user: prevUser, createAccount: false };
            });
            window.location.href = '/';
          });
        }}
      />
    ) : (
      <div>
        <Router>
          <Switch>
            <Route
              exact
              path="/"
              render={() => (
                <div>
                  <HomeAppBar user={this.state.user} />
                  <HomePage
                    definitions={this.state.definitions}
                    categories={this.state.categories}
                  />
                </div>
              )}
            />
            <Route
              exact
              path="/about"
              render={() => (
                <div>
                  <HomeAppBar user={this.state.user} />
                  <AboutPage />
                </div>
              )}
            />
            <Route
              exact
              path="/admin"
              render={() => (
                <div>
                  <HomeAppBar user={this.state.user} />
                  <AdminPage
                    videos={this.state.videos}
                    definitions={this.state.definitions}
                  />
                </div>
              )}
            />
            <Route
              exact
              path="/profile"
              render={() => (
                <div>
                  <HomeAppBar user={this.state.user} />
                  <ProfilePage
                    user={this.state.user}
                    videos={this.state.videos}
                    signOut={() => {
                      firebase.auth().signOut();
                      this.setState({ user: undefined });
                    }}
                  />
                </div>
              )}
            />
            <Route
              path="/add-term"
              render={() => (
                <div>
                  <HomeAppBar user={this.state.user} />
                  <AddTermPage
                    definitions={this.state.definitions}
                    terms={Object.keys(this.state.definitions)}
                    user={this.state.user}
                    addTerm={this.addTerm}
                  />
                </div>
              )}
            />
            <Route
              path="/modify-term"
              render={() => (
                <div>
                  <HomeAppBar user={this.state.user} />
                  <ModifyTermPage
                    definitions={this.state.definitions}
                    terms={Object.keys(this.state.definitions)}
                    user={this.state.user}
                  />
                </div>
              )}
            />
            <Route
              path="/submit-video"
              render={() => (
                <div>
                  <HomeAppBar user={this.state.user} />
                  <AddVideoPage
                    user={this.state.user}
                    terms={Object.keys(this.state.definitions)}
                    addVideo={this.addVideo}
                  />
                </div>
              )}
            />
            <Route
              exact
              path="/sign-in"
              render={() => (
                <div>
                  <HomeAppBar user={this.state.user} />
                  <SignIn user={this.state.user} />
                </div>
              )}
            />
            <Route
              path={'/term/'}
              render={() => (
                <div>
                  <PrimarySearchAppBar user={this.state.user} />
                  <DefinitionPage
                    categories={this.state.categories}
                    definitions={this.state.definitions}
                    videos={this.state.videos}
                    user={this.state.user}
                  />
                </div>
              )}
            />
            <Route
              path={'/search/'}
              render={() => (
                <div>
                  <PrimarySearchAppBar user={this.state.user} />
                  <SearchPage
                    definitions={this.state.definitions}
                    videos={this.state.videos}
                  />
                </div>
              )}
            />
          </Switch>
        </Router>
      </div>
    );
  }
}

const cachedParentTerms = [
  'Medicine',
  'Engineering',
  'Mathematics',
  'General Stem Terminology',
  'Technology',
  'Science',
];

const cachedParentTermData = {
  Medicine: {
    Key: '8639',
    Definition:
      'The science and art dealing with the maintenance of health and the prevention, alleviation, or cure of disease\r\n',
    Source: 'Merriam-Webster on-line',
    Children: {
      'A E Amputation': 'A E Amputation',
      'Health Care Delivery': 'Health Care Delivery',
      'Anatomy (Human)': 'Anatomy (Human)',
      'Medical Specialty': 'Medical Specialty',
      Disease: 'Disease',
    },
  },
  Engineering: {
    Key: '8634',
    Definition:
      'The art or science of making practical application of the knowledge of pure sciences, as physics or chemistry, as in the construction of engines, bridges, buildings, mines, ships, and chemical plants.',
    Source: 'Dictionary.com',
    Children: {
      'Mechanical Engineering': 'Mechanical Engineering',
      Cimt: 'Cimt',
      Manufacturing: 'Manufacturing',
      'Chemical Engineering': 'Chemical Engineering',
      'Materials Science And Engineerin': 'Materials Science And Engineerin',
      'Civil And Environmental Engineer': 'Civil And Environmental Engineer',
      'Industrial Engineering': 'Industrial Engineering',
      'Aeronautics And Astronautics': 'Aeronautics And Astronautics',
      Bioengineering: 'Bioengineering',
    },
  },
  Mathematics: {
    Key: '8640',
    Definition:
      'The study of the measurement, properties, and relationships of quantities and sets, using numbers and symbols. ',
    Source: 'Dictionary.com',
    Children: {
      Cryptography: 'Cryptography',
      Geometry: 'Geometry',
      Algebra: 'Algebra',
      'Applied Math': 'Applied Math',
      Arithmetic: 'Arithmetic',
      Calculus: 'Calculus',
      Trigonometry: 'Trigonometry',
      Precalculus: 'Precalculus',
      'General Math Terminology': 'General Math Terminology',
      'Differential Equations': 'Differential Equations',
      'Multivariable Calculus': 'Multivariable Calculus',
      'Vector Terminology': 'Vector Terminology',
      'Mathematical Analysis': 'Mathematical Analysis',
      'Abstract Algebra': 'Abstract Algebra',
      'Greek Alphabet': 'Greek Alphabet',
      'Set Theory': 'Set Theory',
      'Linear Algebra': 'Linear Algebra',
      'Discrete Mathematics': 'Discrete Mathematics',
      Statistics: 'Statistics',
      'Field Of Topology': 'Field Of Topology',
      'Algebraic Topology': 'Algebraic Topology',
    },
  },
  'General Stem Terminology': {
    Key: '8641',
    Definition:
      'Terminology that is used in many STEM fields.  Usually, non-technical terms with a general meaning.',
    Children: {
      Acronym: 'Acronym',
      Accurate: 'Accurate',
      Analyze: 'Analyze',
      'Approximate / Approximation': 'Approximate / Approximation',
      Inference: 'Inference',
      Fieldwork: 'Fieldwork',
    },
  },
  Technology: {
    Key: '8777',
    Definition:
      'The branch of knowledge that deals with the creation and use of technical means and their interrelation with life, society, and the environment, drawing upon such subjects as industrial arts, engineering, applied science, and pure science.',
    Source: 'Dictionary.com',
    Children: {
      'Technology Companies': 'Technology Companies',
      'Information Technology': 'Information Technology',
      'Information Systems': 'Information Systems',
      'Imaging Technology': 'Imaging Technology',
      'Computer Science': 'Computer Science',
      'Information Science': 'Information Science',
    },
  },
  Science: {
    Key: '8778',
    Definition:
      'Science is systematic knowledge of the physical or material world gained through observation and experimentation.',
    Source: 'Dictionary.com',
    Children: {
      'Natural Science': 'Natural Science',
      Microbiology: 'Microbiology',
      'Social Science': 'Social Science',
    },
  },
};

export default withSnackbar(App);
